import React from 'react'
import LezioneCard from './card/LezioneCard'
import ArticoloCard from './card/ArticoloCard'
import AutoreCard from './card/AutoreCard'
import RaccoltaCard from './card/RaccoltaCard'
import StrumentoCard from './card/StrumentoCard'
import EventoCard from './card/EventoCard'
import FormazioneModuloCard from 'react-components/molecules/FormazioneModuloCard/FormazioneModuloCard'

const SliderItem = React.memo(({ item, type }) => {
  switch (type) {
    case 'strumento':
      return <StrumentoCard strumento={item} />
    case 'raccolta':
      return <RaccoltaCard raccolta={item} classes="u-bg-white" />
    case 'articolo':
      return <ArticoloCard articolo={item} />
    case 'lezione':
      return <LezioneCard articolo={item} />
    case 'autori':
      return <AutoreCard autore={item} />
    case 'eventi':
      return <EventoCard evento={item} />
    case 'modulo':
      return <FormazioneModuloCard item={item} latest={item.novita} />
    default:
      return <></>
  }
})

export default SliderItem
